function updateStickyFacet() {
  let t = document.querySelectorAll("product-facet");
  if (t.length)
    t.forEach((t) => {
      let e = new IntersectionObserver(
        ([t]) =>
          t.target.classList.toggle("is-pinned", !(t.intersectionRatio < 1)),
        { root: t, rootMargin: "-1px 0px 0px 0px", threshold: [1] }
      );
      e.observe(t.querySelector(".collection__facet"));
    });
}
updateStickyFacet();
